import React from 'react';

export default function ButtonPrimary({className, text, disabled, ...other}) {
	return <button className={` button button--primary ${className ? className : ''}`} disabled={disabled} {...other}>
		{text}
	</button>
}
